/*
* Copyright (c) 2023 Eugenio Espinoza
*/

import React from 'react';
import { Link } from 'react-router-dom';
import './HomeFooter.css';

const EXPLORE = [
  { to: '/', label: 'Inicio' },
  { to: '/artists', label: 'Artists' },
  { to: '/videos', label: 'Videos' },
  { to: '/about', label: 'The Label' },
  { to: '/contact', label: 'Contact' },
];

const CONNECT = [
  { href: 'https://www.instagram.com/masteredtrax/', label: 'Instagram' },
  { href: 'https://www.youtube.com/@MasteredTraxVEVO', label: 'YouTube' },
  { href: 'https://www.facebook.com/OfficialMasteredTrax', label: 'Facebook' },
  { href: 'https://twitter.com/MasteredTrax', label: 'X / Twitter' },
];

function HomeFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="mt-foot">
      <div className="mt-container mt-foot__dispatch">
        <span className="mt-foot__dispatchLabel">The Dispatch · N° 001</span>
        <span className="mt-foot__dispatchLabel">Independent Record Label</span>
      </div>

      <div className="mt-container mt-foot__markRow">
        <h2 className="mt-foot__mark">Mastered Trax</h2>
      </div>

      <div className="mt-container mt-foot__signoff">
        <span className="mt-foot__rule" aria-hidden="true" />
        <p>Hasta el próximo número.</p>
        <span className="mt-foot__rule" aria-hidden="true" />
      </div>

      <nav className="mt-container mt-foot__nav" aria-label="Footer">
        <div className="mt-foot__col">
          <span className="mt-kicker">Explore</span>
          <ul>
            {EXPLORE.map((e) => (
              <li key={e.to}><Link to={e.to}>{e.label}</Link></li>
            ))}
          </ul>
        </div>

        <div className="mt-foot__col mt-foot__col--right">
          <span className="mt-kicker">Connect</span>
          <ul>
            {CONNECT.map((c) => (
              <li key={c.href}>
                <a href={c.href} target="_blank" rel="noopener noreferrer">{c.label}</a>
              </li>
            ))}
          </ul>
        </div>
      </nav>

      <div className="mt-container mt-foot__bottom">
        <span>© {year} Mastered Trax · All rights reserved.</span>
        <span className="mt-foot__cities">Guadalajara · Chicago · Est. 2014</span>
      </div>

      <div className="mt-container mt-foot__credit">
        <span className="mt-foot__creditMark" aria-hidden="true" />
        <a
          href="https://eugenioespinoza.com"
          target="_blank"
          rel="noopener noreferrer"
          className="mt-foot__creditLink"
        >
          <span className="mt-foot__creditLabel">Designed &amp; Developed by</span>
          <span className="mt-foot__creditName">Eugenio Espinoza</span>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M7 17 17 7M9 7h8v8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </a>
        <span className="mt-foot__creditMark" aria-hidden="true" />
      </div>
    </footer>
  );
}

export default HomeFooter;
